// 会议相关的东西
export default [
  {
    path: '/meetingOrder',
    name: 'meetingOrder',
    component: () => import ('@/components/page/meeting/meetingOrder')
  },
  {
    path: '/meetingBook',
    name: 'meetingBook',
    component: () => import ('@/components/page/meeting/meetingBook')
  },
  {
    path: '/meetingBookFast',
    name: 'meetingBookFast',
    component: () => import ('@/components/page/meeting/meetingBookFast')
  },
  {
    path: '/meetingCancel',
    name: 'meetingCancel',
    component: () => import ('@/components/page/meeting/meetingCancel')
  },
  {
    path: '/meetingEdit',
    name: 'meetingEdit',
    component: () => import ('@/components/page/meeting/meetingEdit')
  },
  {
    path: '/meetingDetail/:id',
    name: 'meetingDetail',
    component: () => import ('@/components/page/meeting/meetingDetail')
  },

]



// WEBPACK FOOTER //
// ./src/router/modules/meeting.js